import styled, { css } from 'styled-components'
import { Link } from 'gatsby'
import { calculateResponsiveSizeFromTheme } from 'styles/media-queries'
import ArrowLeftIcon from 'images/arrow-left.svg'
import ArrowRightIcon from 'images/arrow-right.svg'
import DboxLogoImage from 'images/dbox_white.svg'

export const LayoutWrapper = styled.div`
  position: relative;
  height: 100%;
`

export const PageWrapper = styled.div`
  position: relative;

  width: 100vw !important;
  height: 56.25vw !important; /* Given a 16:9 aspect ratio, 9/16*100 = 56.25 */
  max-height: 100vh;
  max-width: 177.77vh; /* Given a 16:9 aspect ratio, 16/9*100 = 177.77 */

  overflow: hidden;
  margin: auto;

  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`

export const ContentWrapper = styled.div`
  position: relative;
  overflow: hidden;
  height: 100%;
  width: 79%;
  flex-grow: 1;

  .page {
    top: 0;
    transition: opacity 1s;
    height: 100%;
    width: 100%;
  }
  .page.entering,
  .page.entered {
    position: relative;
    opacity: 1;
  }
  .page.exiting,
  .page.exited {
    position: absolute;
    opacity: 0;
  }
`

const Arrow = css`
  display: block;
  width: ${calculateResponsiveSizeFromTheme(63)};
  height: ${calculateResponsiveSizeFromTheme(52)};
  font-size: 0;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: auto 100%;
  overflow: hidden;
  position: absolute;
  bottom: ${calculateResponsiveSizeFromTheme(80)};
`

export const ArrowLeft = styled(Link)`
  ${Arrow}
  background-image: url(${ArrowLeftIcon});
  left: ${calculateResponsiveSizeFromTheme(80)};
`

export const ArrowRight = styled(Link)`
  ${Arrow}
  background-image: url(${ArrowRightIcon});
  right: ${calculateResponsiveSizeFromTheme(80)};
`

export const PrecachingInfoContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: #000000;
  color: white;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 11;
  align-items: center;
  justify-content: center;
`

export const PrecachingLogo = styled.div`
  display: block;
  border: none;
  background-image: url(${DboxLogoImage});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  height: ${calculateResponsiveSizeFromTheme(300)};
  width: 100%;
  margin: 0 0 ${calculateResponsiveSizeFromTheme(100)} 0;
`
